const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/course-library/courses/$courseId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/course-library/courses/$courseId")({
  beforeLoad: args => requirePermission(Permissions.CourseLibrary.Manage, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});